import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { ChevronIcon } from 'src/domains/layouts/shared/assets/icons/ChevronIcon';

export const CopyRoot = withConfig(theme => styled('div', { label: 'CopyRoot' })<{ isSignup?: boolean }>`
    color: inherit;
    font-size: ${({ isSignup }): string =>
        isSignup === true ? theme.star.fontSize.small : theme.star.fontSize.xRegular};
    line-height: 1.3;
    margin: ${({ isSignup }): string => (isSignup === true ? '0 0 12px' : '8px 0 24px')};
    overflow: visible;
    text-align: left;
`);

export const CopyParagraph = styled('p', { label: 'CopyParagraph' })`
    margin: 0 0 8px;
`;

export const CopyTerm = withConfig(theme => styled('span', { label: 'CopyTerm' })`
    font-weight: ${theme.star.fontWeight.bold};
`);

export const InlineTermWithTooltip = styled('span', { label: 'InlineTermWithTooltip' })`
    align-items: center;
    display: inline-flex;
    gap: 4px;
    vertical-align: middle;
`;

export const CopyHeading = withConfig(theme => styled('p', { label: 'CopyHeading' })`
    font-weight: ${theme.star.fontWeight.bold};
    margin: 12px 0 8px;
`);

export const CalculationTypeRow = styled('div', { label: 'CalculationTypeRow' })`
    align-items: center;
    display: flex;
    gap: 6px;
    margin: 0 0 8px;
`;

export const CalculationTypeLabel = withConfig(theme => styled('span', { label: 'CalculationTypeLabel' })`
    font-weight: ${theme.star.fontWeight.medium};
`);

export const ShowExplanationButton = withConfig(theme => styled('button', { label: 'ShowExplanationButton' })`
    align-items: center;
    appearance: none;
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    display: inline-flex;
    font: inherit;
    font-weight: ${theme.star.fontWeight.medium};
    gap: 4px;
    margin: 0;
    padding: 0;
    text-decoration: underline;
`);

export const ShowExplanationChevron = styled(ChevronIcon, { label: 'ShowExplanationChevron' })`
    fill: currentcolor;
    width: 12px;
`;

export const ExplanationPanel = styled('div', { label: 'ExplanationPanel' })`
    margin: 8px 0 4px;
`;
